
define('inlineSvg!svgs/icon/share-email', function () {return '<span class="inline-share-email inline-icon"><svg width="32" height="32" viewBox="-2 -2 32 32"><path d="M20.2 11.7l-.4-.4-5.7 2.7-5.7-2.7-.3.4 6 4.9 6.1-4.9zM21.4 7H6.5L5 9.5v9.3L6.6 20h14.9l1.5-1.2V9.5L21.4 7zm-.5 10.8H7.1V9.2h13.8v8.6z"/></svg></span>';});

